import { useSelector, useDispatch } from "react-redux";
import { useCallback } from "react";
import {
  getLoading,
  getBusinessActivityKind,
  getSavedPrivatePersonData,
  getSavedOtherBusinessData,
  getSavedSelfEmployedData,
  getSavedInvoicesEnabled,
  getInvoiceCountries,
  getInvoiceFormData,
  getInvoiceFormErrors
} from "../redux/modules/invoices/selector";
import {
  fetchSavedInvoiceData,
  fetchSavedInvoiceDataPromiseCreator,
  fetchInvoiceCountries as fetchInvoiceCountriesAction,
  updateInvoiceFormData as updateInvoiceFormDataAction,
  updateInvoiceFormError as updateInvoiceFormErrorAction,
  updateSavedInvoiceData as updateSavedInvoiceDataAction,
  updateSavedInvoiceDataPromiseCreator
} from "../redux/modules/invoices";

const useInvoices = () => {
  const dispatch = useDispatch();

  const loading = useSelector(getLoading);
  const businessActivityKind = useSelector(getBusinessActivityKind);
  const savedPrivatePersonData = useSelector(getSavedPrivatePersonData);
  const savedOtherBusinessData = useSelector(getSavedOtherBusinessData);
  const savedSelfEmployedData = useSelector(getSavedSelfEmployedData);
  const savedInvoicesEnabled = useSelector(getSavedInvoicesEnabled);
  const invoiceCountries = useSelector(getInvoiceCountries);
  const invoiceFormData = useSelector(getInvoiceFormData);
  const invoiceFormErrors = useSelector(getInvoiceFormErrors);

  const fetchInvoices = useCallback(() => {
    dispatch(fetchSavedInvoiceData());
  }, [dispatch]);

  const fetchSavedInvoiceDataAsync = useCallback(
    payload => fetchSavedInvoiceDataPromiseCreator(payload, dispatch),
    [dispatch]
  );

  const fetchCountries = useCallback(() => {
    dispatch(fetchInvoiceCountriesAction());
  }, [dispatch]);

  const updateInvoiceFormData = useCallback(
    payload => {
      dispatch(updateInvoiceFormDataAction(payload));
    },
    [dispatch]
  );

  const updateInvoiceFormError = useCallback(
    payload => {
      dispatch(updateInvoiceFormErrorAction(payload));
    },
    [dispatch]
  );

  const updateSavedInvoiceData = useCallback(
    payload => {
      dispatch(updateSavedInvoiceDataAction(payload));
    },
    [dispatch]
  );

  const updateSavedInvoiceDataAsync = useCallback(
    payload => updateSavedInvoiceDataPromiseCreator(payload, dispatch),
    [dispatch]
  );

  return {
    loading,
    businessActivityKind,
    savedPrivatePersonData,
    savedOtherBusinessData,
    savedSelfEmployedData,
    savedInvoicesEnabled,
    invoiceCountries,
    invoiceFormData,
    invoiceFormErrors,
    updateInvoiceFormData,
    updateInvoiceFormError,
    updateSavedInvoiceData,
    updateSavedInvoiceDataAsync,
    fetchSavedInvoiceData: fetchInvoices,
    fetchSavedInvoiceDataAsync,
    fetchInvoiceCountries: fetchCountries
  };
};

export default useInvoices;
